<template>
  <div class="layout-container">
    <div class="layout-content">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.layout-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  padding: 24px 16px;
}

.layout-content {
  max-width: 560px;
  width: 100%;
}
</style>
